/** CoStar.Api.Search.Result.Summary.AttachmentType */
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["Unknown"] = 0] = "Unknown";
    AttachmentType[AttachmentType["Aerial"] = 1] = "Aerial";
    AttachmentType[AttachmentType["Financial"] = 2] = "Financial";
    AttachmentType[AttachmentType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    AttachmentType[AttachmentType["BuildingPhoto"] = 4] = "BuildingPhoto";
    AttachmentType[AttachmentType["VirtualTour"] = 5] = "VirtualTour";
    AttachmentType[AttachmentType["Lobby"] = 6] = "Lobby";
    AttachmentType[AttachmentType["Other"] = 7] = "Other";
    AttachmentType[AttachmentType["MarketingBrochure"] = 8] = "MarketingBrochure";
    AttachmentType[AttachmentType["PlatMap"] = 9] = "PlatMap";
    AttachmentType[AttachmentType["FloorPlan"] = 10] = "FloorPlan";
    AttachmentType[AttachmentType["SitePlan"] = 11] = "SitePlan";
    AttachmentType[AttachmentType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    AttachmentType[AttachmentType["Slate"] = 13] = "Slate";
    AttachmentType[AttachmentType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    AttachmentType[AttachmentType["Logo"] = 15] = "Logo";
    AttachmentType[AttachmentType["Map"] = 16] = "Map";
    AttachmentType[AttachmentType["SmallImage"] = 17] = "SmallImage";
    AttachmentType[AttachmentType["LargeImage"] = 18] = "LargeImage";
    AttachmentType[AttachmentType["TenantPhoto"] = 19] = "TenantPhoto";
    AttachmentType[AttachmentType["LeaseDocument"] = 20] = "LeaseDocument";
    AttachmentType[AttachmentType["PublicFiling"] = 21] = "PublicFiling";
    AttachmentType[AttachmentType["Deed"] = 22] = "Deed";
    AttachmentType[AttachmentType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    AttachmentType[AttachmentType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    AttachmentType[AttachmentType["RentAndLeaseAssignment"] = 25] = "RentAndLeaseAssignment";
    AttachmentType[AttachmentType["Loan"] = 26] = "Loan";
    AttachmentType[AttachmentType["Article"] = 27] = "Article";
    AttachmentType[AttachmentType["PressRelease"] = 28] = "PressRelease";
    AttachmentType[AttachmentType["SecuritiesExchangeCommissionFiling"] = 29] = "SecuritiesExchangeCommissionFiling";
    AttachmentType[AttachmentType["CompanyReport"] = 30] = "CompanyReport";
    AttachmentType[AttachmentType["MediaSource"] = 31] = "MediaSource";
    AttachmentType[AttachmentType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    AttachmentType[AttachmentType["InteriorPhoto"] = 33] = "InteriorPhoto";
    AttachmentType[AttachmentType["GoadMap"] = 34] = "GoadMap";
    AttachmentType[AttachmentType["Filler35"] = 35] = "Filler35";
    AttachmentType[AttachmentType["Filler36"] = 36] = "Filler36";
    AttachmentType[AttachmentType["Filler37"] = 37] = "Filler37";
    AttachmentType[AttachmentType["Filler38"] = 38] = "Filler38";
    AttachmentType[AttachmentType["Filler39"] = 39] = "Filler39";
    AttachmentType[AttachmentType["VideoTour"] = 40] = "VideoTour";
})(AttachmentType || (AttachmentType = {}));
